import styled from "styled-components";
import Calendar from 'react-calendar';

export const CustomCalendar = styled(Calendar)`
  .react-calendar__month-view__weekdays abbr {
    text-decoration: none !important;
    border-bottom: none !important;
  }

  .highlight-range {
  background: #d900ff !important; /* ou um dos tons do gradiente */
  color: white;
  border-radius: 0 !important;
}

/* Início do range */
.react-calendar__tile--rangeStart {
  border-top-left-radius: 30% !important;
  border-bottom-left-radius: 30% !important;
}

/* Fim do range */
.react-calendar__tile--rangeEnd {
  background: linear-gradient(90deg, #ff00d6, #af00e3);
  color: white !important;
  border-top-right-radius: 30% !important;
  border-bottom-right-radius: 30% !important;
}

`;

export const Container = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 17px;
`;

export const CalendarContainer = styled.div.attrs({})`
  align-self: flex-end;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  position: relative;
`;

export const ContentContainer = styled.div.attrs({})`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;

  overflow: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(150, 150, 150, 0.5); /* Cor semi-transparente */
    border-radius: 4px;
  }
`;

export const ContentContainerFlex = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  overflow: auto;

   &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(150, 150, 150, 0.5); /* Cor semi-transparente */
    border-radius: 4px;
  }
`;

export const CalendarFilterContainer = styled.div.attrs()`
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: ${(props) => !props.isOpen ? "row" : "row-reverse"};
  align-items: center;
  gap: 12px;
  width: 105px;
  height: fit-content;
  padding: 8px 9px;
  border-radius: 30px;

  background: ${(props) => !props.isOpen ? "#ffffff" : "linear-gradient(90deg, #AF00E3 4%,#FF00D6 99%,#FF00D6 100%)"};

  cursor: pointer;
  transition: background 0.8s ease, transform 0.8s ease;
  `;

export const CalendarFilterText = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: ${(props) =>
    props.isOpen ? "#ffffff" : props.theme.palette.colors.text};
  transition: color 0.8s ease, transform 0.8s ease;
`;

export const RangeDataTextContainer = styled.div.attrs()`
  display: flex;
  width: 100%;
  justify-content: center;
  align-content: center;
  gap: 30px;

  margin-bottom: 15px;
`;

export const RangeDataText = styled.p.attrs()`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.palette.colors.text};
`;

export const CalendarIcon = styled.img.attrs(({ src }) => ({
  src: "/icons/calendar-color.svg",
}))`
width: 34px;
`;

export const CalendarIconClose = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  background: #ffffff;
  color: ${(props) => props.theme.palette.colors.text};
  border-radius: 50%;
`

export const CalendarWrapper = styled('div')({
  position: 'absolute',
  top: '55px',
  right: 0,
  zIndex: 999,
  backgroundColor: '#fff',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
  borderRadius: '26px',

  overflow: 'hidden',
});

export const ConfirmBtn = styled('button')((props) => ({
  all: "unset",

  width: "100%",
  height: "36px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#2724D3",

  color: props.theme.palette.colors.lightprimary,
  fontSize: "12px",
  fontWeight: "700",
}));